"use client";

import { usePathname } from "next/navigation";
import { WorkspaceProvider } from "../workspace";

export function WorkspaceBoundary({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  // Leaving the workspace discards its fictional in-memory data, including on logout.
  if (/^\/(nl|en)\/login\/?$/.test(pathname)) return children;
  return <WorkspaceProvider>{children}</WorkspaceProvider>;
}
